// extracted by mini-css-extract-plugin
export default {"listOfBanksSelector":"ListOfBanksSelector_listOfBanksSelector__0fawx","iconWithText":"ListOfBanksSelector_iconWithText__Txdtg"};